import React from "react";
import { DARWIN_BLUE, DARWIN_NAVY } from "../../../../constants";

export const ExpandOutlineIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.97268 10.7066V13.4066C8.97268 13.6616 9.05908 13.8755 9.23188 14.0483C9.40468 14.2211 9.61828 14.3072 9.87268 14.3066C10.1277 14.3066 10.3416 14.2202 10.5144 14.0474C10.6872 13.8746 10.7733 13.661 10.7727 13.4066V10.7066H13.4727C13.7277 10.7066 13.9416 10.6202 14.1144 10.4474C14.2872 10.2746 14.3733 10.061 14.3727 9.80664C14.3727 9.55164 14.2863 9.33774 14.1135 9.16494C13.9407 8.99214 13.7271 8.90604 13.4727 8.90664H10.7727V6.20664C10.7727 5.95164 10.6863 5.73774 10.5135 5.56494C10.3407 5.39214 10.1271 5.30604 9.87268 5.30664C9.61768 5.30664 9.40378 5.39304 9.23098 5.56584C9.05818 5.73864 8.97208 5.95224 8.97268 6.20664V8.90664H6.27268C6.01768 8.90664 5.80378 8.99304 5.63098 9.16584C5.45818 9.33864 5.37208 9.55224 5.37268 9.80664C5.37268 10.0616 5.45908 10.2755 5.63188 10.4483C5.80468 10.6211 6.01828 10.7072 6.27268 10.7066H8.97268ZM9.87268 18.8066C8.62768 18.8066 7.45768 18.5702 6.36268 18.0974C5.26768 17.6246 4.31518 16.9835 3.50518 16.1741C2.69518 15.3641 2.05408 14.4116 1.58188 13.3166C1.10968 12.2216 0.873281 11.0516 0.872681 9.80664C0.872681 8.56164 1.10908 7.39164 1.58188 6.29664C2.05468 5.20164 2.69578 4.24914 3.50518 3.43914C4.31518 2.62914 5.26768 1.98804 6.36268 1.51584C7.45768 1.04364 8.62768 0.807241 9.87268 0.806641C11.1177 0.806641 12.2877 1.04304 13.3827 1.51584C14.4777 1.98864 15.4302 2.62974 16.2402 3.43914C17.0502 4.24914 17.6916 5.20164 18.1644 6.29664C18.6372 7.39164 18.8733 8.56164 18.8727 9.80664C18.8727 11.0516 18.6363 12.2216 18.1635 13.3166C17.6907 14.4116 17.0496 15.3641 16.2402 16.1741C15.4302 16.9841 14.4777 17.6255 13.3827 18.0983C12.2877 18.5711 11.1177 18.8072 9.87268 18.8066ZM9.87268 17.0066C11.8827 17.0066 13.5852 16.3091 14.9802 14.9141C16.3752 13.5191 17.0727 11.8166 17.0727 9.80664C17.0727 7.79664 16.3752 6.09414 14.9802 4.69914C13.5852 3.30414 11.8827 2.60664 9.87268 2.60664C7.86268 2.60664 6.16018 3.30414 4.76518 4.69914C3.37018 6.09414 2.67268 7.79664 2.67268 9.80664C2.67268 11.8166 3.37018 13.5191 4.76518 14.9141C6.16018 16.3091 7.86268 17.0066 9.87268 17.0066Z"
        fill={DARWIN_BLUE}
      />
    </svg>
  );
};

export const ExpandFillIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.98159 10.7066V13.4066C8.98159 13.6616 9.06799 13.8755 9.24079 14.0483C9.41359 14.2211 9.62719 14.3072 9.88159 14.3066C10.1366 14.3066 10.3505 14.2202 10.5233 14.0474C10.6961 13.8746 10.7822 13.661 10.7816 13.4066V10.7066H13.4816C13.7366 10.7066 13.9505 10.6202 14.1233 10.4474C14.2961 10.2746 14.3822 10.061 14.3816 9.80664C14.3816 9.55164 14.2952 9.33774 14.1224 9.16494C13.9496 8.99214 13.736 8.90604 13.4816 8.90664H10.7816V6.20664C10.7816 5.95164 10.6952 5.73774 10.5224 5.56494C10.3496 5.39214 10.136 5.30604 9.88159 5.30664C9.62659 5.30664 9.41269 5.39304 9.23989 5.56584C9.06709 5.73864 8.98099 5.95224 8.98159 6.20664V8.90664H6.28159C6.02659 8.90664 5.81269 8.99304 5.63989 9.16584C5.46709 9.33864 5.38099 9.55224 5.38159 9.80664C5.38159 10.0616 5.46799 10.2755 5.64079 10.4483C5.81359 10.6211 6.02719 10.7072 6.28159 10.7066H8.98159ZM9.88159 18.8066C8.63659 18.8066 7.46659 18.5702 6.37159 18.0974C5.27659 17.6246 4.32409 16.9835 3.51409 16.1741C2.70409 15.3641 2.06299 14.4116 1.59079 13.3166C1.11859 12.2216 0.882192 11.0516 0.881592 9.80664C0.881592 8.56164 1.11799 7.39164 1.59079 6.29664C2.06359 5.20164 2.70469 4.24914 3.51409 3.43914C4.32409 2.62914 5.27659 1.98804 6.37159 1.51584C7.46659 1.04364 8.63659 0.807241 9.88159 0.806641C11.1266 0.806641 12.2966 1.04304 13.3916 1.51584C14.4866 1.98864 15.4391 2.62974 16.2491 3.43914C17.0591 4.24914 17.7005 5.20164 18.1733 6.29664C18.6461 7.39164 18.8822 8.56164 18.8816 9.80664C18.8816 11.0516 18.6452 12.2216 18.1724 13.3166C17.6996 14.4116 17.0585 15.3641 16.2491 16.1741C15.4391 16.9841 14.4866 17.6255 13.3916 18.0983C12.2966 18.5711 11.1266 18.8072 9.88159 18.8066Z"
        fill={DARWIN_BLUE}
      />
    </svg>
  );
};

export const RequestIcon = () => {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 3.0612C12.9178 3.0612 16.5 5.45231 16.5 8.39453C16.5 9.88787 15.5756 11.239 14.0911 12.2079C15.0422 11.4345 15.6111 10.4568 15.6111 9.39898C15.6111 6.87453 12.4289 4.83898 8.5 4.83898V7.50564L4.94444 3.95009L8.5 0.394531V3.0612ZM8.5 15.5056C4.08222 15.5056 0.5 13.1145 0.5 10.1723C0.5 8.67898 1.42444 7.32787 2.90889 6.35898C1.95778 7.13231 1.38889 8.11009 1.38889 9.17675C1.38889 11.6923 4.57111 13.7279 8.5 13.7279V11.0612L12.0556 14.6168L8.5 18.1723V15.5056Z"
        fill={DARWIN_BLUE}
      />
    </svg>
  );
};

export const QuickRequestIcon = () => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.48889 16.3994C11.0788 16.3994 13.9889 13.4893 13.9889 9.89941C13.9889 6.3095 11.0788 3.39941 7.48889 3.39941C3.89898 3.39941 0.988892 6.3095 0.988892 9.89941C0.988892 13.4893 3.89898 16.3994 7.48889 16.3994Z"
        stroke={DARWIN_BLUE}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M5.19543 1.10547H9.78367M7.48955 6.84076V9.89959H10.5484M7.48955 1.10547V2.63488"
        stroke={DARWIN_BLUE}
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ArrowOutlineIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00554 12.4982V10.3982H13.4055L9.73054 6.72324L11.2215 5.23224L17.4375 11.4482L11.2215 17.6642L9.73054 16.1732L13.4055 12.4982H5.00554ZM21.8055 11.4482C21.8055 14.233 20.6993 16.9037 18.7302 18.8729C16.761 20.842 14.0903 21.9482 11.3055 21.9482C9.92666 21.9482 8.56128 21.6767 7.28737 21.149C6.01345 20.6213 4.85594 19.8479 3.88092 18.8729C1.91179 16.9037 0.805542 14.233 0.805542 11.4482C0.805542 8.66347 1.91179 5.99275 3.88092 4.02362C5.85005 2.05449 8.52077 0.948242 11.3055 0.948242C12.6844 0.948242 14.0498 1.21983 15.3237 1.74751C16.5976 2.27518 17.7551 3.04861 18.7302 4.02362C19.7052 4.99864 20.4786 6.15615 21.0063 7.43007C21.534 8.70398 21.8055 10.0694 21.8055 11.4482ZM19.7055 11.4482C19.7055 9.22042 18.8205 7.08385 17.2452 5.50855C15.6699 3.93324 13.5334 3.04824 11.3055 3.04824C9.07772 3.04824 6.94115 3.93324 5.36584 5.50855C3.79054 7.08385 2.90554 9.22042 2.90554 11.4482C2.90554 13.6761 3.79054 15.8126 5.36584 17.3879C6.94115 18.9632 9.07772 19.8482 11.3055 19.8482C13.5334 19.8482 15.6699 18.9632 17.2452 17.3879C18.8205 15.8126 19.7055 13.6761 19.7055 11.4482Z"
        fill={DARWIN_BLUE}
      />
    </svg>
  );
};

export const ArrowFillIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.4636 11.4482C21.4636 14.233 20.3574 16.9037 18.3882 18.8729C16.4191 20.842 13.7484 21.9482 10.9636 21.9482C9.58474 21.9482 8.21936 21.6767 6.94545 21.149C5.67153 20.6213 4.51402 19.8479 3.539 18.8729C1.56987 16.9037 0.463623 14.233 0.463623 11.4482C0.463623 8.66347 1.56987 5.99275 3.539 4.02362C5.50813 2.05449 8.17885 0.948242 10.9636 0.948242C12.3425 0.948242 13.7079 1.21983 14.9818 1.74751C16.2557 2.27518 17.4132 3.04861 18.3882 4.02362C19.3633 4.99864 20.1367 6.15615 20.6644 7.43007C21.192 8.70398 21.4636 10.0694 21.4636 11.4482ZM4.66362 12.4982H13.0636L9.38862 16.1732L10.8796 17.6642L17.0956 11.4482L10.8796 5.23224L9.38862 6.72324L13.0636 10.3982H4.66362V12.4982Z"
        fill={DARWIN_BLUE}
      />
    </svg>
  );
};

export const PreviewIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.27681 0.727539C6.55743 0.727539 7.7856 1.23626 8.69113 2.14179C9.59666 3.04733 10.1054 4.27549 10.1054 5.55611C10.1054 6.75211 9.6671 7.85154 8.94653 8.6984L9.1471 8.89897H9.73396L13.4482 12.6133L12.334 13.7275L8.61967 10.0133V9.4264L8.4191 9.22582C7.54293 9.97371 6.42877 10.3846 5.27681 10.3847C3.9962 10.3847 2.76803 9.87596 1.8625 8.97043C0.956965 8.06489 0.448242 6.83673 0.448242 5.55611C0.448242 4.27549 0.956965 3.04733 1.8625 2.14179C2.76803 1.23626 3.9962 0.727539 5.27681 0.727539ZM5.27681 2.21325C3.41967 2.21325 1.93396 3.69897 1.93396 5.55611C1.93396 7.41325 3.41967 8.89897 5.27681 8.89897C7.13396 8.89897 8.61967 7.41325 8.61967 5.55611C8.61967 3.69897 7.13396 2.21325 5.27681 2.21325Z"
        fill={DARWIN_NAVY}
      />
    </svg>
  );
};

export const FavoriteOutlineIcon = () => {
  return (
    <svg
      width="28"
      height="20"
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0654297 14.8755V2.43104C0.0654297 2.00327 0.217874 1.63693 0.522763 1.33204C0.827652 1.02716 1.19373 0.874971 1.62099 0.87549H9.39876C9.82654 0.87549 10.1929 1.02793 10.4978 1.33282C10.8027 1.63771 10.9548 2.00379 10.9543 2.43104V14.8755L5.50987 12.5422L0.0654297 14.8755ZM1.62099 12.5033L5.50987 10.831L9.39876 12.5033V2.43104H1.62099V12.5033Z"
        fill="#757575"
      />
    </svg>
  );
};

export const FavoriteFillIcon = () => {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.28418 20.5479V2.77008C0.28418 2.15896 0.501957 1.63563 0.937513 1.20008C1.37307 0.76452 1.89603 0.547113 2.5064 0.547853H13.6175C14.2286 0.547853 14.752 0.765631 15.1875 1.20119C15.6231 1.63674 15.8405 2.15971 15.8397 2.77008V20.5479L8.06196 17.2145L0.28418 20.5479Z"
        fill="#81D4FA"
      />
    </svg>
  );
};

export const LoadingIcon = () => {
  return (
    <svg
      width="28"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="loading-icon"
    >
      <path
        d="M9.59766 4.21452V1.54785M13.3754 5.77007L15.2865 3.85896M14.931 9.54785H17.5977M13.3754 13.3256L15.2865 15.2367M9.59766 14.8812V17.5479M5.81988 13.3256L3.90877 15.2367M4.26432 9.54785H1.59766M5.81988 5.77007L3.90877 3.85896"
        stroke="#424242"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RemoveIcon = () => {
  return (
    <svg
      width="27"
      height="20"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3066 0.28418C20.4566 0.28418 26.3066 6.13418 26.3066 13.2842C26.3066 20.4342 20.4566 26.2842 13.3066 26.2842C6.15664 26.2842 0.306641 20.4342 0.306641 13.2842C0.306641 6.13418 6.15664 0.28418 13.3066 0.28418ZM13.3066 2.88418C10.8366 2.88418 8.62664 3.66418 6.93664 5.09418L21.4966 19.6542C22.7966 17.8342 23.7066 15.6242 23.7066 13.2842C23.7066 7.56418 19.0266 2.88418 13.3066 2.88418ZM19.6766 21.4742L5.11664 6.91418C3.68664 8.60418 2.90664 10.8142 2.90664 13.2842C2.90664 19.0042 7.58664 23.6842 13.3066 23.6842C15.7766 23.6842 17.9866 22.9042 19.6766 21.4742Z"
        fill="#424242"
      />
    </svg>
  );
};

export const OpenRequestDrawerIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M16.2509 1.70193V15.611C16.2509 15.816 16.1695 16.0125 16.0246 16.1574C15.8797 16.3023 15.6831 16.3837 15.4782 16.3837H8.52362V0.929199H15.4782C15.6831 0.929199 15.8797 1.01061 16.0246 1.15553C16.1695 1.30044 16.2509 1.49699 16.2509 1.70193Z"
        fill="#BDBDBD"
      />
      <path
        d="M15.4782 0.15625H1.56908C1.1592 0.15625 0.766103 0.319074 0.476274 0.608903C0.186445 0.898732 0.0236206 1.29182 0.0236206 1.7017V15.6108C0.0236206 16.0207 0.186445 16.4138 0.476274 16.7036C0.766103 16.9934 1.1592 17.1562 1.56908 17.1562H15.4782C15.888 17.1562 16.2811 16.9934 16.571 16.7036C16.8608 16.4138 17.0236 16.0207 17.0236 15.6108V1.7017C17.0236 1.29182 16.8608 0.898732 16.571 0.608903C16.2811 0.319074 15.888 0.15625 15.4782 0.15625ZM1.56908 1.7017H7.75089V15.6108H1.56908V1.7017ZM15.4782 15.6108H9.29635V1.7017H15.4782V15.6108Z"
        fill="#BDBDBD"
      />
    </svg>
  );
};

export const AddToRequestIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4349 10.6826C15.856 10.6826 15.3823 11.1563 15.3823 11.7352V17.2299C15.3823 17.8089 14.9086 18.2826 14.3297 18.2826H3.80334C3.22439 18.2826 2.75071 17.8089 2.75071 17.2299V6.47204C2.75071 5.89309 3.22439 5.41941 3.80334 5.41941H9.0665C9.64545 5.41941 10.1191 4.94572 10.1191 4.36678C10.1191 3.78783 9.64545 3.31414 9.0665 3.31414H2.75071C1.59282 3.31414 0.645447 4.26151 0.645447 5.41941V18.051C0.645447 19.2089 1.59282 20.1563 2.75071 20.1563H15.3823C16.5402 20.1563 17.4876 19.2089 17.4876 18.051V11.7352C17.4876 11.1563 17.0139 10.6826 16.4349 10.6826ZM19.6139 3.31414H17.4876V1.18783C17.4876 0.619408 17.0244 0.15625 16.456 0.15625H16.4244C15.8454 0.15625 15.3823 0.619408 15.3823 1.18783V3.31414H13.2665C12.6981 3.31414 12.2349 3.7773 12.2244 4.34572V4.3773C12.2244 4.95625 12.6876 5.41941 13.2665 5.41941H15.3823V7.5352C15.3823 8.10362 15.8454 8.5773 16.4244 8.56678H16.456C17.0244 8.56678 17.4876 8.10362 17.4876 7.5352V5.41941H19.6139C20.1823 5.41941 20.6454 4.95625 20.6454 4.38783V4.34572C20.6454 3.7773 20.1823 3.31414 19.6139 3.31414Z"
        fill="#BDBDBD"
      />
      <path
        d="M12.2244 7.52466H5.90859C5.32964 7.52466 4.85596 7.99834 4.85596 8.57729C4.85596 9.15624 5.32964 9.62992 5.90859 9.62992H12.2244C12.8033 9.62992 13.277 9.15624 13.277 8.57729C13.277 7.99834 12.8033 7.52466 12.2244 7.52466ZM12.2244 10.6826H5.90859C5.32964 10.6826 4.85596 11.1562 4.85596 11.7352C4.85596 12.3141 5.32964 12.7878 5.90859 12.7878H12.2244C12.8033 12.7878 13.277 12.3141 13.277 11.7352C13.277 11.1562 12.8033 10.6826 12.2244 10.6826ZM12.2244 13.8404H5.90859C5.32964 13.8404 4.85596 14.3141 4.85596 14.8931C4.85596 15.472 5.32964 15.9457 5.90859 15.9457H12.2244C12.8033 15.9457 13.277 15.472 13.277 14.8931C13.277 14.3141 12.8033 13.8404 12.2244 13.8404Z"
        fill="#BDBDBD"
      />
    </svg>
  );
};
